import { Application } from "@hotwired/stimulus"
import * as pdfjsLib from "pdfjs-dist"
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url"

// Configure PDF.js worker for stimulus-pdf-viewer
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
